export default "__VITE_ASSET__1a53ae56__"